import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RemoveIcon from '@mui/icons-material/Remove';
import { ArrayFieldTemplateItemType } from '@rjsf/utils';
import { iconButtonPillStyle } from 'components/button/iconButtonPillStyle';
import { ItemToolbar, removePillStyle } from './ArrayFieldItemTemplate.styles';

export default function ArrayFieldItemTemplate(props: ArrayFieldTemplateItemType) {
  const {
    children,
    disabled,
    hasToolbar,
    hasCopy,
    hasMoveDown,
    hasMoveUp,
    hasRemove,
    index,
    onCopyIndexClick,
    onDropIndexClick,
    onReorderClick,
    readonly,
  } = props;

  const controlsDisabled = !!disabled || !!readonly;

  return (
    <Grid container alignItems="center" wrap="nowrap">
      <Grid item xs style={{ overflow: 'auto', minWidth: 0 }}>
        <Box sx={{ pt: 2, pb: 1 }}>{children}</Box>
      </Grid>
      {hasToolbar && (
        <Grid item>
          <ItemToolbar>
            {(hasMoveUp || hasMoveDown) && (
              <Tooltip title="Move up">
                <span style={{ display: 'inline-flex' }}>
                  <IconButton
                    size="small"
                    aria-label="move up"
                    sx={iconButtonPillStyle}
                    disabled={controlsDisabled || !hasMoveUp}
                    onClick={onReorderClick(index, index - 1)}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            {(hasMoveUp || hasMoveDown) && (
              <Tooltip title="Move down">
                <span style={{ display: 'inline-flex' }}>
                  <IconButton
                    size="small"
                    aria-label="move down"
                    sx={iconButtonPillStyle}
                    disabled={controlsDisabled || !hasMoveDown}
                    onClick={onReorderClick(index, index + 1)}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            {hasCopy && (
              <Tooltip title="Duplicate">
                <span style={{ display: 'inline-flex' }}>
                  <IconButton
                    size="small"
                    aria-label="duplicate"
                    sx={iconButtonPillStyle}
                    disabled={controlsDisabled}
                    onClick={onCopyIndexClick(index)}
                  >
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            {hasRemove && (
              <Tooltip title="Remove">
                <span style={{ display: 'inline-flex' }}>
                  <IconButton
                    size="small"
                    aria-label="remove"
                    sx={removePillStyle}
                    disabled={controlsDisabled}
                    onClick={onDropIndexClick(index)}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </ItemToolbar>
        </Grid>
      )}
    </Grid>
  );
}
